import { render, staticRenderFns } from "./ManagementInfo.vue?vue&type=template&id=3166d8e9&scoped=true"
var script = {}
import style0 from "./ManagementInfo.vue?vue&type=style&index=0&id=3166d8e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3166d8e9",
  null
  
)

export default component.exports